'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RankedListToggle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseCheckbox = require('@bibliocommons/base-checkbox');

var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);

require('../styles/RankedToggle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  isRanked: _react.PropTypes.bool.isRequired,
  handleListPropertyChange: _react.PropTypes.func.isRequired
};

var RankedListToggle = exports.RankedListToggle = function (_BcReactComponent) {
  _inherits(RankedListToggle, _BcReactComponent);

  function RankedListToggle(props) {
    _classCallCheck(this, RankedListToggle);

    var _this = _possibleConstructorReturn(this, (RankedListToggle.__proto__ || Object.getPrototypeOf(RankedListToggle)).call(this, props));

    _this.bindAll('handleChange');
    return _this;
  }

  _createClass(RankedListToggle, [{
    key: 'handleChange',
    value: function handleChange(val) {
      this.props.handleListPropertyChange(_immutable2.default.Map({ isRanked: val }));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-user-list-ranked-toggle' },
        _react2.default.createElement(_baseCheckbox2.default, {
          id: 'ranked-list-toggle',
          checked: this.props.isRanked === true,
          handleChange: this.handleChange,
          labelTestId: 'ranked-toggle-label',
          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_ranked_list' }) })
      );
    }
  }]);

  return RankedListToggle;
}(_baseBcReactComponent2.default);

RankedListToggle.propTypes = propTypes;

exports.default = RankedListToggle;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/ranked-toggle/components/RankedToggle.component.js
// module id = 1331
// module chunks = 0